import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {LatLng} from 'leaflet';

@Injectable({
  providedIn: 'root'
})
export class MapService {

  public onFocusCenter: BehaviorSubject<LatLng> = new BehaviorSubject<LatLng>(undefined);
  public onDeleteMarker: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

  doFocusCenter(center: LatLng) {
    this.onFocusCenter.next(center);
  }

  doDeleteMarker(id: string) {
    this.onDeleteMarker.next(id);
  }
}
